import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import SurveySubRespondents from './NewSurveySubRespondents';

const NewSurveySubRespondentContainer = (props) => {
  const {
    managers, peers, directReports, others, respondent, handleAddRespondent, handleRemoveRespondent,
  } = props;

  const selectedRespondents = [
    ...managers,
    ...peers,
    ...directReports,
    ...others,
    { respondent },
  ].map((selected => selected.respondent));

  return (
    <div className="p-grid">
      <div className="p-col-12 border-bottom">
        <h2 className="mt20">
          <FormattedMessage id="respondent.plural" defaultMessage="Respondents" />
        </h2>
      </div>
      <div className="p-col-6">
        <SurveySubRespondents
          type="managers"
          subRespondents={managers}
          selectedRespondents={selectedRespondents}
          onAdd={handleAddRespondent}
          onRemove={handleRemoveRespondent}
        />
      </div>
      <div className="p-col-6">
        <SurveySubRespondents
          type="peers"
          subRespondents={peers}
          selectedRespondents={selectedRespondents}
          onAdd={handleAddRespondent}
          onRemove={handleRemoveRespondent}
        />
      </div>
      <div className="p-col-6">
        <SurveySubRespondents
          type="directReports"
          subRespondents={directReports}
          selectedRespondents={selectedRespondents}
          onAdd={handleAddRespondent}
          onRemove={handleRemoveRespondent}
        />
      </div>
      <div className="p-col-6">
        <SurveySubRespondents
          type="others"
          selectedRespondents={selectedRespondents}
          subRespondents={others}
          onAdd={handleAddRespondent}
          onRemove={handleRemoveRespondent}
        />
      </div>
    </div>
  );
};

NewSurveySubRespondentContainer.propTypes = {
  managers: PropTypes.arrayOf(PropTypes.any).isRequired,
  peers: PropTypes.arrayOf(PropTypes.any).isRequired,
  directReports: PropTypes.arrayOf(PropTypes.any).isRequired,
  others: PropTypes.arrayOf(PropTypes.any).isRequired,
  respondent: PropTypes.objectOf(PropTypes.any).isRequired,
  handleAddRespondent: PropTypes.func.isRequired,
  handleRemoveRespondent: PropTypes.func.isRequired,
};

export default NewSurveySubRespondentContainer;
